// =============================================================
// 📊 OperatorLoadChart.jsx — Carga de trabalho por operador
// =============================================================
//
// Espera dados no formato:
// data = [
//   { operator: "Ana", active: 3, pending: 1 },
//   { operator: "Bruno", active: 5, pending: 2 },
//   ...
// ]
//
// Mostramos quantas sessões ativas + pendentes cada operador está cuidando.
//

import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from "recharts";

function buildChartData(raw) {
  if (!raw || !Array.isArray(raw)) return [];

  return raw.map((item) => ({
    operator: item.operator || item.name || "—",
    active: Number(item.active || 0),
    pending: Number(item.pending || 0),
  }));
}

export default function OperatorLoadChart({ data }) {
  const chartData = buildChartData(data);

  if (!chartData || chartData.length === 0) {
    return (
      <div className="ia-chart-empty">
        Sem dados de carga de trabalho ainda.
      </div>
    );
  }

  return (
    <div className="ia-chart-wrapper">
      <ResponsiveContainer width="100%" height={240}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f3c5d8" />
          <XAxis
            dataKey="operator"
            tick={{ fontSize: 11, fill: "#b22857" }}
          />
          <YAxis tick={{ fontSize: 11, fill: "#b22857" }} />
          <Tooltip
            formatter={(value, name) => {
              if (name === "active") return [value, "Ativas"];
              if (name === "pending") return [value, "Pendentes"];
              return [value, name];
            }}
            labelFormatter={(label) => `Operador: ${label}`}
          />
          <Legend />

          <Bar
            dataKey="active"
            name="Ativas"
            fill="#d81b60"
            radius={[4, 4, 0, 0]}
          />
          <Bar
            dataKey="pending"
            name="Pendentes"
            fill="#f48fb1"
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
